module.exports = __webpack_public_path__ + "img/sucess.117a673c.svg";